import request from './request';

// 作品商城商品列表
export function getGoodsList(params) {
  return request({
    url: '/mail/products/goods/list',
    method: 'get',
    params
  });
}

// 作品商城款式分类
export function getGoodsStyleClass() {
  return request({
    url: '/mail/products/goods/style_class',
    method: 'get',
  });
}

// 定制商品列表
export function getDingzhiList(params) {
  return request({
    url: '/mail/products/dingzhi/list',
    method: 'get',
    params
  });
}

// 定制商品款式分类
export function getDingzhiStyleClass() {
  return request({
    url: '/mail/products/dingzhi/style_class',
    method: 'get',
  });
}

// 获取商品详情
export function getProductDetail(id) {
  return request({
    url: `/mail/products/detail/${id}`,
    method: 'get'
  });
}

